<template>
  <div class="Paginate paginate-warp w-full py-4">
    <sliding-pagination
      :current="pagination.currentPage"
      :total="pagination.length"
      :slidingWindowSize="7"
      :slidingEndingSize="3"
      @page-change="pageChangeHandler"
      :aria-goto-page-label="'跳转到第 {page} 页'"
    >
    </sliding-pagination>
  </div>
</template>

<script>
import SlidingPagination from 'vue-sliding-pagination'
export default {
  name: 'pagination',

  props: {
    pagination: {
      type: Object
    }
  },

  components: {
    SlidingPagination
  },

  methods: {
    pageChangeHandler (selectedPage) {
      this.$emit('pageChangeHandler', selectedPage)
    }
  }
}
</script>

<style lang="scss">
  @import "~vue-sliding-pagination/dist/style/sliding-pagination";
  .paginate-warp {
    text-align: center;
    display: flex;
    justify-content: center;
  }
  .c-sliding-pagination {
    text-align: center;
    margin: 1.5em 0;
  }
  .c-sliding-pagination__list-element {
    // background: #ffffff;
    // color: #2c3e50;
    padding: 0;
    // border-radius: 0;
    // margin-bottom: 0;
    // margin-right: .5em;
    &:hover {
      // background: #ffffff;
      // color: #2c3e50;
      // border-bottom: 1px solid #646565;
    }
    .c-sliding-pagination__page {
      display: block;
      padding: 0.6em 0.8em;
      font-size: 0.8rem;
      border-radius: 0;
      cursor: pointer;
      background: #ffffff;
      color: black;
      &:hover {
        background: rgb(230, 0, 18, 0.3) !important;
        color: rgb(0, 0, 0) !important;
      }
    }
  }
  .c-sliding-pagination__list-element--active {
    position: relative;
    // border-bottom: 1px solid #646565;
    cursor: default;
    a {
      background: #e60012 !important;
      color: rgb(255, 255, 255) !important;
      cursor: default;
    }
  }
  .c-sliding-pagination__list-element
  ~ .c-sliding-pagination__list-element--disabled {
  cursor: default;
  background-color: #fff;
    &:hover {
      background: #ffffff;
      color: #2c3e50;
    }
  }
</style>
